/**
 * Cookies helper for hiding/showing elems
 */
 export default class CookiesHelper {
    /**
    * Function that is triggered when accept all is clicked
    *
    * @param {String|null} selector for element which should be hidden
    */
    acceptAllCookies(selector) {
        let locale = $('meta[name="country"]').attr('content');

        $.ajax({
            headers: {
                'X-App-Locale': locale
            },
            url: window.origin + '/cookie/set-accept-all',
            method: 'POST',
            success: (data) => {
                if (selector !== undefined && selector != '') {
                    $(selector).hide();
                }

                $('#analytical_cookie')[0].checked = true;
            }
        })
    }

    /**
    * Function that is triggered when accept all is clicked
    *
    * @param {String|null} selector for element which should be hidden
    */
    acceptSelectedCookies(selector) {
        let locale = $('meta[name="country"]').attr('content');

        $.ajax({
            headers: {
                'X-App-Locale': locale,
            },
            data: {
                'analytical': $('#analytical_cookie')[0].checked ? 1 : 0
            },
            url: window.origin + '/cookie/set-accept-selected',
            method: 'POST',
            success: (data) => {
                if (selector !== undefined && selector != '') {
                    $(selector).hide();
                }
            }
        })
    }
 }